<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Select <br>Organization
      </h1>
      <br>
      <p class="subheader-style">
        Select an organization under you want to check-in.
      </p>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi-close
        </v-icon>
      </v-btn>
      <template v-for="(item, i) in userOrganizations">
        <v-col
          :key="i"
          cols="12"
          md="12"
        >
          <div
            class="select-list-style"
            @click="continueCheckInProcess(item)"
          >
            {{ item.organization.name }}
          </div>
        </v-col>
      </template>
      <center-spinner
        :loading="loading"
      />
    </div>
  </v-dialog>
</template>

<script>
  import spinner from '../../../components/SpinnerCentre.vue';
  export default {
    name: 'SelectOrganization',
    components: {
      'center-spinner': spinner,
    },
    data: () => ({
      loading: false,
      showModal: true,
    }),
    computed: {
      userOrganizations () {
        return this.$store.getters['organization/getUserOrganizations'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.getUserOrganizations();
    },
    methods: {
      async getUserOrganizations () {
        this.loading = true;
        await this.$store.dispatch('organization/fetchUserOrganizations', {
          params: {
            requestStatus: 'accepted',
          },
        }).catch(() => {
          this.loading = false;
        });
        this.loading = false;
      },
      continueCheckInProcess (item) {
        this.loading = true;
        this.$store.dispatch('organization/selectedOrganization', item);
        alert(item);
        setTimeout(() => {
          this.$emit('organization-selected');
          this.loading = false;
        }, 1000);
      },
    },
  };
</script>
